import type { OfferPreset } from "../../types"

import hero from "@/features/offers/assets/aura/hero.webp"
import feature1 from "@/features/offers/assets/aura/feature-1.svg"
import feature2 from "@/features/offers/assets/aura/feature-2.webp"
import feature3 from "@/features/offers/assets/aura/feature-3.webp"
import gift from "@/features/offers/assets/aura/gift.webp"
import card1 from "@/features/offers/assets/aura/card-1.webp"
import card2 from "@/features/offers/assets/aura/card-2.webp"
import chipEmotions from "@/features/offers/assets/aura/chip-emotions.svg"
import chipMotives from "@/features/offers/assets/aura/chip-motives.svg"
import chipPresence from "@/features/offers/assets/aura/chip-presence.svg"
import chipAbsorption from "@/features/offers/assets/aura/chip-absorption.svg"
import chipSilence from "@/features/offers/assets/aura/chip-silence.webp"
import chipLoyalty from "@/features/offers/assets/aura/chip-heart.svg"
import reviewer1 from "@/features/offers/assets/aura/reviewer-1.webp"
import reviewer2 from "@/features/offers/assets/aura/reviewer-2.webp"
import reviewer3 from "@/features/offers/assets/aura/reviewer-3.webp"

export const auraPreset: OfferPreset = {
  key: "aura",
  stepLabel: "Aura",
  unlockedLabel: "Exclusive Aura Scan Report unlocked",
  hero: {
    title: "Reveal Your Aura",
    subtitle:
      "Discover what your energy reveals about your inner self, emotional patterns, natural strengths, and the way you connect with the world.",
    bg: hero,
    fullBleed: false,
  },
  benefits: [
    {
      icon: feature1,
      title: "Your Aura Signature",
      subtitle: "Discover your aura colors, archetype, and the energy you naturally carry.",
    },
    {
      icon: feature2,
      title: "Sensitivity Profile",
      subtitle: "See how strongly you respond to energy, intuition, and the world around you.",
    },
    {
      icon: feature3,
      title: "Your Power Channels",
      subtitle: "Reveal the natural ways your energy has the strongest impact on others.",
    },
  ],
  gift: {
    title: "Personal Aura Ritual",
    subtitle: "A personalized ritual to reset and release absorbed energy.",
    image: gift,
    strikePrice: "$19.99",
    fillImage: true,
  },
  price: {
    heading: "Your Personal Aura Reading Awaits",
    reportLabel: "Aura Scan Report",
    giftLabel: "Personal Aura Ritual",
  },
  ctaLabel: "Unlock My Aura",
  ctaStickyLabel: "Unlock Aura Scan Report",
  featureCards: {
    heading: "Discover What Your Aura Reveals About You",
    cards: [
      {
        image: card1,
        title: "Your Superpowers",
        subtitle:
          "Discover the natural strengths behind your energy — how you read emotions, sense what lies beneath the surface, and influence the people around you.",
        chips: [
          { icon: chipEmotions, label: "Emotions" },
          { icon: chipMotives, label: "Motives" },
          { icon: chipPresence, label: "Presence" },
        ],
      },
      {
        image: card2,
        title: "Your Growth Edges",
        subtitle:
          "Discover where your natural sensitivity can become overwhelming — and the patterns that may hold you back.",
        chips: [
          { icon: chipAbsorption, label: "Absorption", tone: "cyan" },
          { icon: chipSilence, label: "Silence", tone: "green" },
          { icon: chipLoyalty, label: "Loyalty", tone: "peach" },
        ],
      },
    ],
  },
  reviews: {
    heading: "What users say after discovering their aura",
    items: [
      {
        avatar: reviewer1,
        name: "Rose Bennett",
        rating: "4.9",
        text: "I didn’t expect it to feel so personal. The way it described my sensitivity to other people’s energy felt incredibly accurate.",
      },
      {
        avatar: reviewer2,
        name: "Connor Pike",
        rating: "4.8",
        text: "Seeing my strengths and growth edges together helped me understand myself in a completely new way.",
      },
      {
        avatar: reviewer3,
        name: "Helen Mitchell",
        rating: "5.0",
        text: "I loved that it went beyond my aura color and explained how my energy patterns show up in everyday life.",
      },
    ],
  },
}
